import firebase from 'firebase/compat/app'
import { isCoachSelectionTestVariant } from 'nove8/cohorts/woofz_woofy1/abtest/isCoachSelectionTestVariant'
import { toWoofyChatApiVersion } from 'nove8/cohorts/woofz_woofy1/helpers/toWoofyChatApiVersion'
import { getWoofyCreative } from 'nove8/helpers/api/getWoofyCreative'
import { storeWoofyCreative } from 'nove8/helpers/api/storeWoofyCreative'

export function syncWoofyCreative({
  creativeId,
  leadId,
  firebaseRemoteConfig,
}: {
  creativeId: string
  leadId: string
  firebaseRemoteConfig?: firebase.remoteConfig.RemoteConfig | null
}): void {
  const isCoachFlow = isCoachSelectionTestVariant(firebaseRemoteConfig)
  const apiVersion = toWoofyChatApiVersion(isCoachFlow)

  getWoofyCreative({ creativeId, apiVersion })
  storeWoofyCreative({ creativeId, leadId, apiVersion })
}
